function closeSettingsPanel(settingsPanel, mainSettingsPage) {
    setTimeout(() => {
        if (settingsPanel.getActivePage() !== mainSettingsPage)
            settingsPanel.setActivePage(mainSettingsPage);
    }, 100);
}
export function handleSubtitleListBoxItemSelected(subtitleSettingsOpenButton, settingsPanel, mainSettingsPage) {
    return (e) => {
        for (const item of e.getItems()) {
            if (item.key === e.getSelectedItem()) {
                subtitleSettingsOpenButton.setText(item.label);
                e.selectItem(item.key);
            }
        }
        closeSettingsPanel(settingsPanel, mainSettingsPage);
    };
}
export function handleSpeedListBoxItemSelected(player, speedSettingsOpenButton, settingsPanel, mainSettingsPage) {
    return (source, args) => {
        for (const item of source.getItems()) {
            if (item.key === args) {
                player.setPlaybackSpeed(Number.parseFloat(item.key));
                speedSettingsOpenButton.setText(item.label);
                source.selectItem(item.key);
            }
        }
        closeSettingsPanel(settingsPanel, mainSettingsPage);
    };
}
export function handleQualityListBoxItemSelected(player, qualitySettingsOpenButton, settingsPanel, mainSettingsPage) {
    return (source, args) => {
        for (const item of source.getItems()) {
            if (item.key === args) {
                player.setVideoQuality(item.key);
                qualitySettingsOpenButton.setText(item.label);
                source.selectItem(item.key);
            }
        }
        closeSettingsPanel(settingsPanel, mainSettingsPage);
    };
}
